import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useListChatsQuery } from '@/services/endpoints/chat';
import { Loader } from '@/components/common/Loader';
import { formatRelative } from '@/lib/format';

export function ChatList() {
  const { t } = useTranslation('general');
  const { data, isLoading, isError } = useListChatsQuery({ page: 1 });

  return (
    <div className="flex flex-col gap-4 px-4 pb-6 pt-5">
      <header>
        <h1 className="text-2xl font-bold text-fg">{t('chat', { defaultValue: 'Chat' })}</h1>
        <p className="mt-1 text-sm text-fg-muted">
          {t('chat_subtitle', { defaultValue: 'Match and team conversations' })}
        </p>
      </header>

      {isLoading && (
        <div className="flex h-40 items-center justify-center">
          <Loader />
        </div>
      )}

      {isError && (
        <div className="rounded-xl bg-bg-secondary p-6 text-center text-sm text-danger">
          {t('chat_load_error', { defaultValue: 'Failed to load chats.' })}
        </div>
      )}

      {!isLoading && !isError && !data?.length && (
        <div className="rounded-xl bg-bg-secondary p-6 text-center text-sm text-fg-muted">
          {t('chat_empty', { defaultValue: 'No active conversations yet.' })}
        </div>
      )}

      <ul className="flex flex-col gap-1">
        {data?.map((room) => (
          <li key={room.channel}>
            <Link
              to={`/chat/${encodeURIComponent(room.channel)}`}
              className="flex items-center gap-3 rounded-xl bg-bg-secondary p-3 transition-opacity active:opacity-80"
            >
              <div className="relative h-12 w-12 shrink-0 overflow-hidden rounded-full bg-bg-tertiary">
                {room.image && (
                  <img
                    src={room.image}
                    alt=""
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                )}
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <p className="truncate text-sm font-semibold text-fg">{room.title}</p>
                {room.last_message && (
                  <p className="truncate text-xs text-fg-muted">
                    {room.last_message.message}
                  </p>
                )}
              </div>
              {room.last_message && (
                <span className="shrink-0 text-[10px] text-fg-muted">
                  {formatRelative(room.last_message.created_at)}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
